import { useState } from "react";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import VideoOverlay from "@/components/VideoOverlay";
import ScrollVideoBackground from "@/components/ScrollVideoBackground";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import Features from "@/components/Features";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  const [entered, setEntered] = useState(false);

  return (
    <ReactLenis root options={{ lerp: 0.08, duration: 1.4 }}>
      <div className="bg-canvas text-ink min-h-screen">
        <ScrollVideoBackground />
        <div className="noise-overlay" aria-hidden="true" />
        <AnimatePresence>
          {!entered && <VideoOverlay onEnter={() => setEntered(true)} />}
        </AnimatePresence>
        <Navbar onReplay={() => setEntered(false)} />
        <main className="relative z-10">
          <Hero entered={entered} />
          <EditorialMarquee />
          <Manifesto />
          <Features />
          <Contact />
        </main>
        <Footer />
        <div className="relative z-10">
          <Toaster position="bottom-right" theme="dark" richColors />
        </div>
      </div>
    </ReactLenis>
  );
}

export default App;
